/**
 * Shared toast API — all app notifications should import from here.
 * Global close button, durations, and styling are configured in `@/components/ui/sonner`.
 */
export { toast } from "sonner";
